module.exports = __webpack_public_path__ + "static/img/img41.5ae5898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img41.png
// module id = ALK5
// module chunks = 1